import {
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCT_BY_UNIQUE_ID_SUCCESS,
  GET_PRODUCT_BY_UNIQUE_ID_FAILED,
  CLEAR_PRODUCT
} from "../actions/productActions";

const initState = {
  products: [],
  productByUniqueId: {},
  allProducts: [],
  loading: false,
};

const productReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_PRODUCTS_SUCCESS:
      return { ...state, products: action.payload, loading: false };

    case CLEAR_PRODUCT:
      return { ...state, productByUniqueId: {}, loading: true };

    case GET_PRODUCT_BY_UNIQUE_ID_SUCCESS:
      return { ...state, productByUniqueId: action.payload, loading: false };

    case GET_PRODUCT_BY_UNIQUE_ID_FAILED:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default productReducer;
